import { NotificationsContext } from './NotificationsContext';
import { getDescription } from '@/app/features/admin/notifications/steps/utils';
import { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { NotificationWithAcceptance } from '@ssar-app/domain';
import { Flex, Text } from '@chakra-ui/react';
import { Empty, Modal, Pagination } from '@ssar-app/uikit';

interface NotificationModalProps {
  showNotifications: boolean;
  setShowNotifications: (val: boolean) => void;
}

export const NotificationsModal = (props: NotificationModalProps) => {
  const { showNotifications, setShowNotifications } = props;
  const { notifications } = useContext(NotificationsContext);
  const [notifs, setNotifs] = useState<NotificationWithAcceptance[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setNotifs([...notifications]);
  }, [notifications]);

  const handleModalClose = () => {
    setShowNotifications(false);
    setCurrentPage(1);
  };

  return (
    <Modal
      isOpen={showNotifications}
      header={
        <Text fontSize='lg' mb={0}>
          Notifications
        </Text>
      }
      scrollBehavior='outside'
      contentProps={{ maxWidth: '3xl' }}
      showOk={false}
      showCancel
      onClose={() => handleModalClose()}
      cancelButtonProps={{ variant: 'outline', colorScheme: 'gray' }}
      bodyProps={{ padding: 4 }}
    >
      <>
        {notifs
          .slice((currentPage - 1) * 5, currentPage * 5)
          .map((notification, index) => (
            <Flex
              p={3}
              flexDirection='column'
              border='1px solid'
              borderColor='gray.300'
              borderRadius='base'
              bg='green.100'
              mt={index !== 0 ? 4 : 0}
              key={index}
            >
              <Flex>
                <Text mb={0} fontWeight='semibold'>
                  {notification.title}
                </Text>
                <Text mb={0} ml='auto' fontSize='small' mr={1} color='gray.700'>
                  {moment(notification.updatedOn).fromNow()}
                </Text>
              </Flex>
              {getDescription(notification)}
            </Flex>
          ))}
        {notifs.length === 0 && <Empty description='No Notifications' />}
        <Pagination
          current={currentPage}
          total={notifs.length}
          pageSize={5}
          onChange={(page) => setCurrentPage(page)}
          hideOnSinglePage
          containerProps={{ mt: 4, ml: 2 }}
          showTotal={(total, range) =>
            `Showing ${range[0]}-${range[1]} of ${total} items`
          }
        />
      </>
    </Modal>
  );
};
